import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LeadDetailComponent } from './lead-detail.component';
import { AuthGuard } from 'src/app/core/auth/guards/auth.guard';


const routes: Routes = [
  {
    path: ':leadId',
    component: LeadDetailComponent,
    canActivate: [AuthGuard]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeadDetailRoutingModule { }
